import React, { Component } from 'react'

import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import BlankCard from '../../../components/ui/cards/BlankCard'
import LottieLoader from '../../../components/ui/lotties/LottieLoader'
import PageTitle from '../../../components/ui/typography/PageTitle'
import selectors from '../../../store/shared/selectors'
import sendFullStoryEvent from '../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../utils/constants/fullstory'
import withOutcomes from '../../../utils/graphql/hocs/withOutcomes'
import uberFacts from '../../../assets/usageTips/tips.json'

import Outcomes from './components/Outcomes'
import { performClearDimMName, performGetUnivInfo } from './outcomesDuck'
import sendSentryEvent from '../../../utils/analyticsHelpers/sendSentryEvent'

class AuthenticatedOutcomesIndex extends Component {
  constructor(props) {
    super(props)

    this.state = {
      company: null,
      eduCategory: null,
      industry: null,
      skill: null,
      employers: null,
      jobCategories: null,
      skills: null,
      degrees: null,
      isClearingFilters: false,
    }

    this.handleCompanyClick = async data => {
      let { company, eduCategory, industry, skill } = this.state
      if (company === data.key) company = null
      else company = data.key
      this.setState({ company })
      await this.updateData(company, eduCategory, industry, skill)

      if (company) {
        const eventProperties = {
          employer_str: company,
        }
        sendFullStoryEvent(fullstory.eventNames.filterByEmployer, eventProperties)
      }
    }

    this.handleEduCategoryClick = async data => {
      let { company, eduCategory, industry, skill } = this.state
      if (eduCategory === data.key) eduCategory = null
      else eduCategory = data.key
      this.setState({ eduCategory })
      await this.updateData(company, eduCategory, industry, skill)

      if (eduCategory) {
        const eventProperties = {
          major_str: eduCategory,
        }
        sendFullStoryEvent(fullstory.eventNames.filterByMajor, eventProperties)
      }
    }

    this.handleIndustryClick = async data => {
      let { company, eduCategory, industry, skill } = this.state
      if (industry === data.key) industry = null
      else industry = data.key
      this.setState({ industry })
      await this.updateData(company, eduCategory, industry, skill)

      if (industry) {
        const eventProperties = {
          job_category_str: industry,
        }
        sendFullStoryEvent(fullstory.eventNames.filterByJobCategory, eventProperties)
      }
    }

    this.handleSkillClick = async data => {
      let { company, eduCategory, industry, skill } = this.state
      if (skill === data.key) skill = null
      else skill = data.key
      this.setState({ skill })
      await this.updateData(company, eduCategory, industry, skill)

      if (skill) {
        const eventProperties = {
          skill_str: skill,
        }
        sendFullStoryEvent(fullstory.eventNames.filterBySkill, eventProperties)
      }
    }

    this.getParams = ({ dimName, demoAudited, demoSchoolCatalog }) => {
      const universityGeneralCatalogSetting = get(this.props, 'univInfo.useGeneralCatalog', true)

      const useGeneralCatalog =
        demoSchoolCatalog === true
          ? false
          : demoSchoolCatalog === false
          ? true
          : universityGeneralCatalogSetting

      const params = {
        universities: [dimName],
        useNrmSchoolName: !demoAudited,
        useGeneralCatalog,
      }
      return params
    }

    this.updateData = async (company, eduCategory, industry, skill) => {
      const filters = {}
      if (company) filters['c_current_employers'] = [company]
      if (eduCategory) filters['c_majors'] = [eduCategory]
      if (industry) filters['c_industries'] = [industry]
      if (skill) filters['c_skills'] = [skill]
      await this.updateUnivData(filters)
    }

    this.clearFilters = async () => {
      this.setState({ isClearingFilters: true })
      await this.updateData(null, null, null, null)
      this.setState({
        company: null,
        eduCategory: null,
        industry: null,
        skill: null,
        isClearingFilters: false,
      })
    }

    this.updateUnivData = async filters => {
      const { demoAudited, demoDimName, demoSchoolCatalog, getOutcomesData, univInfo } = this.props
      const dimName = univInfo.dimName
      const finalDimName = demoDimName ? demoDimName : dimName
      await getOutcomesData({
        ...this.getParams({ dimName: finalDimName, demoAudited, demoSchoolCatalog }),
        ...filters,
      })
    }

    this.clearFiltersOnState = () => {
      this.setState({
        company: null,
        eduCategory: null,
        industry: null,
        skill: null,
      })
    }
  }

  componentWillMount() {
    const {
      demoAudited,
      demoDimName,
      demoSchoolCatalog,
      getOutcomesData,
      getUnivInfo,
      insToken,
    } = this.props

    // First get university info to get dim name for outcomes data request to ecarmen
    if (insToken) {
      getUnivInfo({ insToken }).then(data => {
        const finalDimName = demoDimName ? demoDimName : get(data, 'dimName', '')
        getOutcomesData(this.getParams({ dimName: finalDimName, demoAudited, demoSchoolCatalog }))
      })
    }
  }

  componentDidMount() {
    const { outcomesData } = this.props
    if (outcomesData) {
      const { employers, jobCategories, degrees, skills } = outcomesData
      this.setState({ employers, jobCategories, skills, degrees })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      demoAudited,
      demoSchoolCatalog,
      dimName,
      getOutcomesData,
      loadingOutcomesData,
      outcomesData,
    } = this.props

    const clickMajors = get(outcomesData, 'click_facets.click_majors')
    const degrees = !loadingOutcomesData && !!outcomesData && clickMajors

    if (degrees && !degrees.length) {
      sendSentryEvent('Outcomes Module - Small Sample Size')
    }

    if (
      prevProps.dimName !== dimName ||
      prevProps.demoAudited !== demoAudited ||
      prevProps.demoSchoolCatalog !== demoSchoolCatalog
    ) {
      getOutcomesData(this.getParams({ dimName, demoAudited, demoSchoolCatalog }))
      this.clearFiltersOnState()
    }
    if (!isEqual(prevProps.outcomesData, outcomesData) && !!outcomesData) {
      const { employers, jobCategories, degrees, skills } = outcomesData
      const { company, eduCategory, industry, skill } = this.state
      const updatingFilters = {}
      if (!company) updatingFilters['employers'] = employers
      if (!industry) updatingFilters['jobCategories'] = jobCategories
      if (!eduCategory) updatingFilters['degrees'] = degrees
      if (!skill) updatingFilters['skills'] = skills
      this.setState({ ...updatingFilters })
    }
  }

  componentWillUnmount() {
    this.props.clearDimName()
  }

  render() {
    const { isMobile, outcomesData, demoShortName, loadingOutcomesData, univInfo } = this.props
    const {
      company,
      eduCategory,
      industry,
      skill,
      employers,
      jobCategories,
      degrees,
      skills,
      isClearingFilters,
    } = this.state
    const finalShortName = demoShortName ? demoShortName : get(univInfo, 'name', '')

    return (
      <div className="main-page" style={{ marginBottom: 250 }}>
        <PageTitle content="Your School's Outcomes" />
        {outcomesData && (
          <BlankCard notCard noPad delay={0.5}>
            <Outcomes
              handleClearFilters={this.clearFilters}
              isClearingFilters={isClearingFilters}
              handleCompanyClick={this.handleCompanyClick}
              handleEduCategoryClick={this.handleEduCategoryClick}
              handleIndustryClick={this.handleIndustryClick}
              handleSkillClick={this.handleSkillClick}
              isMobile={isMobile}
              isPerformingRequest={loadingOutcomesData}
              selectedCompany={company}
              selectedMajor={eduCategory}
              selectedIndustry={industry}
              selectedSkill={skill}
              univData={outcomesData}
              employers={employers}
              jobCategories={jobCategories}
              degrees={degrees}
              skills={skills}
              shortName={finalShortName}
            />
          </BlankCard>
        )}
        {!outcomesData && loadingOutcomesData && (
          <LottieLoader
            height={500}
            width={300}
            isReady={!loadingOutcomesData}
            animationName="GEARS"
            loadingTime={3000}
            isMobile={isMobile}
            noMessage
            uberFacts={uberFacts}
          >
            <div />
          </LottieLoader>
        )}
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  return state => ({
    demoAudited: get(state, 'demo.audited', true),
    demoDimName: get(state, 'demo.dimName'),
    demoSchoolCatalog: get(state, 'demo.schoolCatalog'),
    demoShortName: get(state, 'demo.shortName'),
    insToken: state.insToken.insToken,
    isMobile: selectors.isLessThanMedium(state),
    totalCount: state.outcomes.totalCount,
    univInfo: state.outcomes.univInfo,
  })
}

/**
 * @const mapDispatchToProps
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUnivInfo: performGetUnivInfo,
      clearDimName: performClearDimMName,
    },
    dispatch,
  )

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(withOutcomes(AuthenticatedOutcomesIndex))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Outcomes/AuthenticatedOutcomesIndex.js